/**
 * Credits — hook + primitives shared across Dashboard / Credits page / Editor.
 * Backend = source of truth. This module only reads.
 */
import { useEffect, useState, useCallback } from 'react';
import api from '@/lib/api';

export const useCredits = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get('/credits/summary');
      setSummary(r.data);
      setError(null);
    } catch (e) {
      setError(e?.response?.data?.detail || 'unavailable');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { summary, loading, error, refresh };
};

export const formatResetDate = (iso, lang = 'fr') => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString(lang === 'fr' ? 'fr-FR' : 'en-US', {
      day: 'numeric', month: 'short', year: 'numeric',
    });
  } catch { return '—'; }
};
